import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Revelation() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-171">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-173">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-12 text-center" data-id="element-174">
            La Revelación
          </h2>

          <div className="space-y-8 text-charcoal/80 text-lg md:text-xl leading-relaxed" data-id="element-175">
            <p data-id="element-176">
              La ciencia moderna nos ha mostrado que para la mujer 40+,{' '}
              <strong data-id="element-177">la caloría no es la unidad de medida que importa</strong>.
              Lo es la{' '}
              <span className="text-gold font-semibold" data-id="element-178">señal hormonal</span>.
            </p>

            <p data-id="element-179">
              Después de años de investigación, hemos descubierto que puedes
              "engañar" a tu metabolismo para que vuelva a quemar grasa
              simplemente{' '}
              <strong data-id="element-180">
                cambiando el orden y el momento en que comes ciertos alimentos
              </strong>
              .
            </p>

            <div className="bg-warm-white p-8 md:p-10 rounded-lg shadow-lg my-10" data-id="element-181">
              <p className="font-serif text-2xl md:text-3xl text-charcoal text-center" data-id="element-182">
                No se trata de restricción, sino de{' '}
                <span className="text-gold" data-id="element-183">sincronización</span>.
              </p>
            </div>

            <p data-id="element-184">
              Cuando silencias la insulina y el cortisol, tu cuerpo deja de
              retener agua y grasa por miedo. El resultado es un descenso de
              medidas que parece magia, pero es simplemente{' '}
              <span className="italic font-serif text-gold text-2xl" data-id="element-185">
                biología recuperada
              </span>
              .
            </p>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="mt-12 text-center" data-id="element-186">
            <motion.a href="#final-cta" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full lg:w-auto bg-forest text-warm-white px-8 py-5 rounded-md text-base md:text-lg font-semibold inline-flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-187">
              SÍ, QUIERO RECUPERAR MI CUERPO Y MI ENERGÍA — ACCESO INMEDIATO
              <ArrowRightIcon className="w-5 h-5" data-id="element-188" />
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}